import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, EmptyState, PageHeader, Row, Table, TextField } from "@plataforma/design-system";
import type { Client, ClientScheduleSummary } from "@plataforma/shared";
import { useAppConfig } from "../../app/config";
import { api } from "../../lib/api";
import { useClients } from "./api";
import { ClientForm } from "./ClientForm";

export function ClientsPage() {
  const { config, format, has } = useAppConfig();
  const terms = config.settings.terms.client;
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [creating, setCreating] = useState(false);
  const clients = useClients(query);
  // A agenda é outra funcionalidade: o resumo só é pedido quando ela existe nesta aplicação.
  const summaries = useQuery({ queryKey: ["appointments", "client-summary"], enabled: has("agenda"), queryFn: async () => (await api.get<{ summaries: ClientScheduleSummary[] }>("/appointments/client-summary")).summaries });
  const summaryOf = (id: string) => summaries.data?.find((item) => item.clientId === id);
  const items = clients.data ?? [];

  return (
    <>
      <PageHeader title={terms.plural} actions={<Button variant="primary" onClick={() => setCreating(true)}>＋ Novo cadastro</Button>} />
      <Row align="between" style={{ marginBottom: 12 }}>
        <div style={{ width: "min(360px, 100%)" }}>
          <TextField label={`Filtrar ${terms.plural.toLowerCase()}`} type="search" placeholder="Nome, telefone ou e-mail" value={query} onChange={(event) => setQuery(event.target.value)} />
        </div>
        <span className="ds-muted ds-small">{items.length} {items.length === 1 ? "cadastro" : "cadastros"}</span>
      </Row>
      <Card>
        <Table<Client>
          items={items}
          rowKey={(client) => client.id}
          onRowClick={(client) => navigate(`/clientes/${client.id}`)}
          empty={<EmptyState>{clients.isPending ? "Carregando…" : "Nenhum cadastro encontrado."}</EmptyState>}
          columns={[
            { header: terms.singular, cell: (client) => <strong>{client.name}</strong> },
            { header: "Contato", cell: (client) => <>{client.phone}{client.email ? <div className="ds-muted ds-small">{client.email}</div> : null}</> },
            ...(has("agenda")
              ? [
                  { header: "Última consulta", cell: (client: Client) => { const date = summaryOf(client.id)?.lastCompletedDate; return date ? format.date(date) : "—"; } },
                  { header: "Próxima consulta", cell: (client: Client) => { const next = summaryOf(client.id)?.nextAppointment; return next ? `${format.date(next.date)} · ${next.time}` : "—"; } },
                ]
              : []),
          ]}
        />
      </Card>
      {creating ? <ClientForm onClose={() => setCreating(false)} onSaved={(client) => navigate(`/clientes/${client.id}`)} /> : null}
    </>
  );
}
